import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderOne from "../components/HeaderThree";
import FooterOne from "../components/FooterThree";
import ServiceInnerDetails from "../components/CookiesPolicyDetails";



const Internship = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>
      {/* Preloader */}
      {active === true && <Preloader />}

      {/* Helmet */}
      <HelmetReact title={"Service Details"} />

      {/* HeaderFive */}
      <HeaderOne />

      {/* Breadcrumb */}
      {/* <Breadcrumb title="Service Details" /> */}

      {/* ServiceDetails */}
      <ServiceInnerDetails />


      {/* Newsletter */}
      {/* <Newsletter /> */}

      {/* FooterOne */}
      <FooterOne />

    </>
  );
};

export default Internship;
